import { useSelector } from 'react-redux';

export const useLiveDocs = () => {
  const liveDocs = useSelector((s) => s.liveDocs);
  return liveDocs.groups;
};
